
export const playerColor = ({ user, masterName, masterColor }) => {
  if (user === masterName) return masterColor; // master color
  return masterColor === 'white' ? 'black' : 'white'; // opposite color of master
};

export const getPlayerDetails = ({ currentUser, player1, player2, masterName, masterColor }) => {
  const localPlayer = {};
  localPlayer.color = playerColor({ user: currentUser, masterName, masterColor });
  localPlayer.name = currentUser;
  const opponent = {};
  opponent.color = localPlayer.color === 'white' ? 'black' : 'white';
  opponent.name = currentUser === player1 ? player2 : player1;
  return ({ localPlayer, opponent });
};

